export const environment = {
  production: true,
  api: 'https://backend-staging.ml-dickes.lu',
  localStorage: {
    accessToken: 'ml_access_token',
    language: 'ml_language'
  },
  GOOGLE_MAPS_KEY: 'AIzaSyD2KldhualGmZ2msYRDBzbOMHx063Tc_4U',
  firebase: {
    apiKey: 'AIzaSyABWtMEtXOHrA_87qSblUrzF3I_7DaFBxE',
    authDomain: 'mldickes-staging.firebaseapp.com',
    projectId: 'mldickes-staging',
    storageBucket: 'mldickes-staging.firebasestorage.app',
    messagingSenderId: '753241444053',
    appId: '1:753241444053:web:909e313415b5f420b49c5c'
  }
};
